import React from 'react'
import './TagIcon.scss'
import clamp from 'lodash/clamp'
import isNum from 'lodash/isNumber'

export default ({tag, fluid, value, defaultTag, ...props}) => {
  if (tag === null) {
    return (
      <span className="gauge fa-stack fa-lg">
        <i className="fa-regular fa-square fa-stack-2x" />
        <i className="fa fa-line-chart fa-stack-1x" />
      </span>
    )
  }
  const {ymin, ymax, calibration} = tag

  const params = {min: ymin, max: ymax, value: value}
  switch (defaultTag || tag.tag) {
    case 'psr':
      return <Pressure {...params} {...props} />
    case 'spsr':
      switch (fluid || (calibration && calibration.fluid)) {
        case 'oil':
          return <StockTank {...params} {...props} />
        case 'chemical':
          return <ChemicalTank {...params} {...props} />
        default:
          return <WaterTank {...params} {...props} />
      }
    case 'dspsr':
      switch (fluid || (calibration && calibration.fluid)) {
        case 'oil':
          return <StockTank {...params} {...props} />
        case 'chemical':
          return <ChemicalTank {...params} {...props} />
        default:
          return <WaterTank {...params} {...props} />
      }
    case 'puls':
      return <FlowMeter {...params} {...props} />
    case 'pult':
      return <FlowMeter {...params} {...props} />
    case 'vib':
      return <Vibration {...params} {...props} />
    case 'temp':
      return <Thermometer {...params} {...props} />
    case 'rot':
      return <BeamPump {...params} {...props} />
    case 'SCADA':
      return <SCADA {...params} {...props}/>
    case 'vlv':
      return <ValvePosition {...params} {...props} />
    case '_v':
      return (
        <span className="gauge fa-stack fa-lg">
          <i className="fa-regular fa-square fa-stack-2x" />
          <i
            className="fa fa-battery-three-quarters fa-stack-1x"
            style={{fontSize: '0.75em'}}
          />
        </span>
      )
    case '_t':
      return (
        <span className="gauge fa-stack fa-lg">
          <i className="fa-regular fa-square fa-stack-2x" />
          <i className="fa fa-thermometer-quarter fa-stack-1x" />
        </span>
      )

    default:
      return (
        <span className="gauge fa-stack fa-lg">
          <i className="fa-regular fa-square fa-stack-2x" />
          <i className="fa fa-line-chart fa-stack-1x" />
        </span>
      )
  }
}

const Vibration = (props) => {
  return (
    <svg
      id="master-artboard"
      viewBox="0 0 360 360"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.width || '100%'}
      enableBackground="new 0 0 1096 780"
    >
      <rect
        id="ee-background"
        x="0"
        y="0"
        width="360"
        height="360"
        style={{fill: 'white', fillOpacity: 0, pointerEvents: 'none'}}
      />
      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="191.293"
        y1="347.9785"
        x2="191.293"
        y2="61.9786"
      >
        <stop offset="0" style={{stopColor: '#00FF00'}} />
        <stop offset="5.322349e-02" style={{stopColor: '#00F80D'}} />
        <stop offset="0.2859" style={{stopColor: '#00DC40'}} />
        <stop offset="0.5046" style={{stopColor: '#00C668'}} />
        <stop offset="0.7031" style={{stopColor: '#00B685'}} />
        <stop offset="0.8748" style={{stopColor: '#00AC97'}} />
        <stop offset="1" style={{stopColor: '#00A99D'}} />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M295,348H87.6c-21.7,0-39.3-17.6-39.3-39.3V101.3C48.3,79.6,65.9,62,87.6,62H295&#10;&#9;&#9;&#9;c21.7,0,39.3,17.6,39.3,39.3v207.4C334.3,330.4,316.7,348,295,348z"
        transform="matrix(1, 0, 0, 1, -11.945890805336546, -28.15816936769815)"
        style={{fill: 'rgb(125, 132, 138)', stroke: 'rgb(82, 82, 82)'}}
      />
      <linearGradient
        id="SVGID_2_"
        gradientUnits="userSpaceOnUse"
        x1="191.293"
        y1="695.9786"
        x2="191.293"
        y2="409.9785"
      >
        <stop offset="2.252073e-03" style={{stopColor: '#FCEE21'}} />
        <stop offset="1.868928e-02" style={{stopColor: '#FCEA21'}} />
        <stop offset="0.2599" style={{stopColor: '#F8B722'}} />
        <stop offset="0.4865" style={{stopColor: '#F58F23'}} />
        <stop offset="0.6923" style={{stopColor: '#F37224'}} />
        <stop offset="0.8702" style={{stopColor: '#F16024'}} />
        <stop offset="1" style={{stopColor: '#F15A24'}} />
      </linearGradient>
      <linearGradient
        id="SVGID_3_"
        gradientUnits="userSpaceOnUse"
        x1="548"
        y1="347.9785"
        x2="548"
        y2="61.9786"
      >
        <stop offset="1.116071e-03" style={{stopColor: '#C1272D'}} />
        <stop offset="9.454818e-02" style={{stopColor: '#C9362B'}} />
        <stop offset="0.3694" style={{stopColor: '#DD5E25'}} />
        <stop offset="0.6207" style={{stopColor: '#EB7B21'}} />
        <stop offset="0.838" style={{stopColor: '#F48D1F'}} />
        <stop offset="0.9966" style={{stopColor: '#F7931E'}} />
      </linearGradient>
      <linearGradient
        id="SVGID_4_"
        gradientUnits="userSpaceOnUse"
        x1="548"
        y1="695.9786"
        x2="548"
        y2="409.9785"
      >
        <stop offset="0" style={{stopColor: '#662D91'}} />
        <stop offset="0.2446" style={{stopColor: '#5453A9'}} />
        <stop offset="0.5876" style={{stopColor: '#3D82C8'}} />
        <stop offset="0.8506" style={{stopColor: '#2EA0DB'}} />
        <stop offset="1" style={{stopColor: '#29ABE2'}} />
      </linearGradient>
      <linearGradient
        id="SVGID_5_"
        gradientUnits="userSpaceOnUse"
        x1="904.707"
        y1="347.9785"
        x2="904.707"
        y2="61.9786"
      >
        <stop offset="0" style={{stopColor: '#00FFFF'}} />
        <stop offset="0.2608" style={{stopColor: '#0FE0F4'}} />
        <stop offset="0.5561" style={{stopColor: '#1DC3EA'}} />
        <stop offset="0.8127" style={{stopColor: '#26B1E4'}} />
        <stop offset="1" style={{stopColor: '#29ABE2'}} />
      </linearGradient>
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1="904.707"
        y1="695.9786"
        x2="904.707"
        y2="409.9785"
      >
        <stop offset="0" style={{stopColor: '#FF00FF'}} />
        <stop offset="8.315808e-02" style={{stopColor: '#FA03EA'}} />
        <stop offset="0.3085" style={{stopColor: '#EC09B7'}} />
        <stop offset="0.5203" style={{stopColor: '#E20E8F'}} />
        <stop offset="0.7125" style={{stopColor: '#DA1172'}} />
        <stop offset="0.8788" style={{stopColor: '#D61360'}} />
        <stop offset="1" style={{stopColor: '#D4145A'}} />
      </linearGradient>
      <defs>
        <path
          id="SVGID_7_"
          d="M652.1,348H444.7c-21.7,0-39.3-17.6-39.3-39.3V101.3c0-21.7,17.6-39.3,39.3-39.3h207.4&#10;&#9;&#9;&#9;&#9;&#9;c21.7,0,39.3,17.6,39.3,39.3v207.4C691.4,330.4,673.8,348,652.1,348z"
        />
        <radialGradient
          id="gradient-0"
          gradientUnits="objectBoundingBox"
          cx="0.5"
          cy="0.5"
          r="0.5"
        >
          <stop offset="0" style={{stopColor: '#43434'}} />
          <stop offset="1" style={{stopColor: '#10101'}} />
        </radialGradient>
        <radialGradient
          id="gradient-1"
          gradientUnits="objectBoundingBox"
          cx="0.5"
          cy="0.5"
          r="0.5"
          gradientTransform="matrix(2.62301838412713, -0.005966874333333649, 0.0022747517786819715, 0.9999972236308218, -0.8126465917261081, 0.0029847589122611873)"
        >
          <stop offset="0" style={{stopColor: '#43434'}} />
          <stop offset="1" style={{stopColor: '#10101'}} />
        </radialGradient>
        <radialGradient
          id="gradient-2"
          gradientUnits="objectBoundingBox"
          cx="0.5"
          cy="0.5"
          r="0.5"
        >
          <stop offset="0" style={{stopColor: '#6b6a6'}} />
          <stop offset="1" style={{stopColor: '#38383'}} />
        </radialGradient>
      </defs>
      <clipPath id="SVGID_8_">
        <use overflow="visible" />
      </clipPath>
      <defs>
        <path
          id="SVGID_9_"
          d="M295,696H87.6c-21.7,0-39.3-17.6-39.3-39.3V449.3c0-21.7,17.6-39.3,39.3-39.3H295&#10;&#9;&#9;&#9;&#9;&#9;c21.7,0,39.3,17.6,39.3,39.3v207.4C334.3,678.4,316.7,696,295,696z"
        />
      </defs>
      <clipPath id="SVGID_10_">
        <use overflow="visible" />
      </clipPath>
      <defs>
        <path
          id="SVGID_11_"
          d="M87.6,62H295c21.7,0,39.3,17.6,39.3,39.3v207.4c0,21.7-17.6,39.3-39.3,39.3H87.6&#10;&#9;&#9;&#9;&#9;&#9;c-21.7,0-39.3-17.6-39.3-39.3V101.3C48.3,79.6,65.9,62,87.6,62z"
        />
      </defs>
      <clipPath id="SVGID_12_">
        <use overflow="visible" />
      </clipPath>
      <path
        fill="#FFFFFF"
        d="M235.9,83.2c0,0,0.1,0,0.1,0c3.9,0.1,7.1,2.9,7.6,6.7l16.9,121.4l19.9-37.4c1.4-2.5,4-4.1,6.9-4.1h52.7&#10;&#9;&#9;&#9;&#9;&#9;c4.3,0,7.8,3.5,7.8,7.8c0,4.3-3.5,7.8-7.8,7.8h-48L263,239.9c-1.6,3-4.9,4.6-8.3,4c-3.3-0.6-5.9-3.3-6.4-6.6l-13.2-94.9&#10;&#9;&#9;&#9;&#9;&#9;l-30,177.8c-0.7,3.9-4.3,6.7-8,6.5c-3.9-0.1-7.1-3.1-7.5-7l-15.4-152.2l-12.8,68.8c-0.7,3.8-4.2,6.6-8,6.4&#10;&#9;&#9;&#9;&#9;&#9;c-3.9-0.1-7.1-3.1-7.5-6.9l-5.8-50.5l-9,26.1c-1.2,3.4-4.6,5.6-8.2,5.2c-3.6-0.4-6.5-3.2-6.9-6.8l-4.7-36.9l-6.6,9.2&#10;&#9;&#9;&#9;&#9;&#9;c-1.5,2-3.8,3.3-6.3,3.3h-56c-4.3,0-7.8-3.5-7.8-7.8c0-4.3,3.5-7.8,7.8-7.8h52l15.9-22.1c1.9-2.6,5.1-3.8,8.3-3&#10;&#9;&#9;&#9;&#9;&#9;c3.1,0.8,5.4,3.4,5.8,6.6l3,23.4l9.3-26.9c1.2-3.4,4.6-5.6,8.2-5.2c3.6,0.4,6.5,3.2,6.9,6.9l3.8,33.1l13.3-71.4&#10;&#9;&#9;&#9;&#9;&#9;c0.7-3.8,4.2-6.6,8-6.4c3.9,0.2,7.1,3.2,7.4,7l15,148.7l28.8-170.7C228.8,86,232.1,83.2,235.9,83.2z"
        transform="matrix(1, 0, 0, 1, -12.799168586730957, -27.30489158630371)"
        style={{fill: 'rgb(198, 149, 0)', stroke: 'rgb(101, 77, 0)'}}
      />
      <defs>
        <path
          id="SVGID_13_"
          d="M1008.4,348H801c-21.7,0-39.3-17.6-39.3-39.3V101.3c0-21.7,17.6-39.3,39.3-39.3h207.4&#10;&#9;&#9;&#9;&#9;&#9;c21.7,0,39.3,17.6,39.3,39.3v207.4C1047.7,330.4,1030.1,348,1008.4,348z"
        />
      </defs>
      <clipPath id="SVGID_14_">
        <use overflow="visible" />
      </clipPath>
      <defs>
        <path
          id="SVGID_15_"
          d="M651.7,696H444.3c-21.7,0-39.3-17.6-39.3-39.3V449.3c0-21.7,17.6-39.3,39.3-39.3h207.4&#10;&#9;&#9;&#9;&#9;&#9;c21.7,0,39.3,17.6,39.3,39.3v207.4C691,678.4,673.4,696,651.7,696z"
        />
      </defs>
      <clipPath id="SVGID_16_">
        <use overflow="visible" />
      </clipPath>

      <path
        d="M 244.51611328125 200.14566040039062 L 244.51611328125 200.14566040039062"
        style={{
          fill: 'rgb(152, 114, 3)',
          fillOpacity: 1,
          stroke: 'rgb(101, 77, 0)',
          strokeOpacity: 1,
          strokeWidth: 1,
          paintOrder: 'stroke'
        }}
      />
    </svg>
  )
}

const FlowMeter = (props) => {
  return (
    <svg
      id="master-artboard"
      viewBox="0 0 320 320"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.width || '100%'}
      enableBackground="new 0 0 1400 980"
    >
      <rect
        id="ee-background"
        x="0"
        y="0"
        width="320"
        height="320"
        style={{fill: 'white', fillOpacity: 0, pointerEvents: 'none'}}
      />
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <g>
          <path
            d="M 263.700012 598.5 H 272.200012 V 651.400002 H 263.700012 V 598.5 Z"
            fill="#CC4552"
            style={{fill: 'rgb(194, 147, 52)'}}
          />
          <path
            fill="#8DBEB2"
            d="M275.5,612.7h-11.8v-72.3c0-11.5,9.3-20.9,20.9-20.9h11.8v72.3C296.3,603.4,287,612.7,275.5,612.7z"
            style={{fill: 'rgb(150, 150, 150)'}}
          />
          <path
            fill="#7FB2A5"
            d="M296.3,591.8v-72.3h-11.8c-2.2,0-4.3,0.3-6.3,1v91.9C288.4,611.2,296.3,602.4,296.3,591.8z"
            style={{fill: 'rgb(125, 125, 125)'}}
          />
        </g>
        <g>
          <path
            d="M 263.700012 647.599976 H 272.200012 V 700.499977 H 263.700012 V 647.599976 Z"
            fill="#CC4552"
            style={{fill: 'rgb(194, 147, 52)'}}
          />
          <path
            fill="#8DBEB2"
            d="M260.4,686.3h11.8v72.3c0,11.5-9.3,20.9-20.9,20.9h-11.8v-72.3C239.5,695.6,248.9,686.3,260.4,686.3z"
            style={{fill: 'rgb(150, 150, 150)'}}
          />
          <path
            fill="#7FB2A5"
            d="M239.5,707.1v72.3h11.8c2.2,0,4.3-0.3,6.3-1v-91.9C247.4,687.8,239.5,696.6,239.5,707.1z"
            style={{fill: 'rgb(125, 125, 125)'}}
          />
          <path
            d="M 821.2908935546875 958.1965942382812"
            style={{
              fill: 'rgb(194, 147, 52)',
              fillOpacity: 1,
              stroke: 'rgb(0, 0, 0)',
              strokeOpacity: 1,
              strokeWidth: 0,
              paintOrder: 'fill'
            }}
          />
        </g>
      </g>
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <path
          d="M 251.399994 601.799988 H 259.899994 V 654.699989 H 251.399994 V 601.799988 Z"
          transform="matrix(0.866 -0.5 0.5 0.866 -279.8619 211.9916)"
          fill="#CC4552"
          style={{fill: 'rgb(194, 147, 52)'}}
        />
        <path
          fill="#8DBEB2"
          d="M256,613.9l-10.2,5.9l-36.1-62.6c-5.8-10-2.3-22.7,7.6-28.5l10.2-5.9l36.1,62.6&#10;&#9;&#9;&#9;&#9;&#9;C269.4,595.4,266,608.1,256,613.9z"
          style={{fill: 'rgb(150, 150, 150)'}}
        />
        <path
          fill="#7FB2A5"
          d="M263.7,585.4l-36.1-62.6l-10.2,5.9c-1.9,1.1-3.6,2.5-5,4l46,79.6C266.5,606.1,269,594.5,263.7,585.4z"
          style={{fill: 'rgb(125, 125, 125)'}}
        />
      </g>
      <path
        d="M 276 644.299988 H 284.5 V 697.199989 H 276 V 644.299988 Z"
        transform="matrix(0.8659999966621399, -0.5, 0.5, 0.8659999966621399, -405.48297119140625, -257.0386962890625)"
        fill="#CC4552"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
      <path
        fill="#8DBEB2"
        d="M279.8,685.1l10.2-5.9l36.1,62.6c5.8,10,2.3,22.7-7.6,28.5l-10.2,5.9l-36.1-62.6&#10;&#9;&#9;&#9;&#9;&#9;C266.4,703.6,269.8,690.9,279.8,685.1z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(150, 150, 150)'}}
      />
      <path
        fill="#7FB2A5"
        d="M272.2,713.6l36.1,62.6l10.2-5.9c1.9-1.1,3.6-2.5,5-4l-46-79.6C269.3,692.9,266.9,704.4,272.2,713.6z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(125, 125, 125)'}}
      />
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <path
          d="M 242.399994 610.799988 H 250.899994 V 663.699989 H 242.399994 V 610.799988 Z"
          transform="matrix(0.5 -0.866 0.866 0.5 -428.5126 532.2226)"
          fill="#CC4552"
          style={{fill: 'rgb(194, 147, 52)'}}
        />
        <path
          fill="#8DBEB2"
          d="M239.8,624.6l-5.9,10.2l-62.6-36.1c-10-5.8-13.4-18.5-7.6-28.5l5.9-10.2l62.6,36.1&#10;&#9;&#9;&#9;&#9;&#9;C242.2,601.8,245.6,614.6,239.8,624.6z"
          style={{fill: 'rgb(150, 150, 150)'}}
        />
        <path
          fill="#7FB2A5"
          d="M232.2,596.1L169.6,560l-5.9,10.2c-1.1,1.9-1.9,3.9-2.3,6l79.6,46C245,612.6,241.4,601.4,232.2,596.1z"
          style={{fill: 'rgb(125, 125, 125)'}}
        />
      </g>
      <path
        d="M 284.899994 635.299988 H 293.399994 V 688.199989 H 284.899994 V 635.299988 Z"
        transform="matrix(0.5, -0.8659999966621399, 0.8659999966621399, 0.5, -536.1559448242188, 94.33051300048828)"
        fill="#CC4552"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
      <path
        fill="#8DBEB2"
        d="M296,674.4l5.9-10.2l62.6,36.1c10,5.8,13.4,18.5,7.6,28.5l-5.9,10.2l-62.6-36.1&#10;&#9;&#9;&#9;&#9;&#9;C293.7,697.1,290.3,684.4,296,674.4z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(150, 150, 150)'}}
      />
      <path
        fill="#7FB2A5"
        d="M303.7,702.9l62.6,36.1l5.9-10.2c1.1-1.9,1.9-3.9,2.3-6l-79.6-46C290.9,686.4,294.5,697.6,303.7,702.9z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(125, 125, 125)'}}
      />
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <path
          d="M 216.899994 645.200012 H 269.799995 V 653.700012 H 216.899994 V 645.200012 Z"
          fill="#CC4552"
          style={{fill: 'rgb(194, 147, 52)'}}
        />
        <path
          fill="#8DBEB2"
          d="M231.1,642v11.8h-72.3c-11.5,0-20.9-9.3-20.9-20.9v-11.8h72.3C221.8,621.1,231.1,630.4,231.1,642z"
          style={{fill: 'rgb(150, 150, 150)'}}
        />
        <path
          fill="#7FB2A5"
          d="M210.3,621.1H138v11.8c0,2.2,0.3,4.3,1,6.3H231C229.6,629,220.9,621.1,210.3,621.1z"
          style={{fill: 'rgb(125, 125, 125)'}}
        />
      </g>
      <path
        d="M 266 645.200012 H 318.900002 V 653.700012 H 266 V 645.200012 Z"
        fill="#CC4552"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
      <path
        fill="#8DBEB2"
        d="M304.7,657v-11.8H377c11.5,0,20.9,9.3,20.9,20.9v11.8h-72.3C314.1,677.9,304.7,668.5,304.7,657z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(150, 150, 150)'}}
      />
      <path
        fill="#7FB2A5"
        d="M325.6,677.9h72.3v-11.8c0-2.2-0.3-4.3-1-6.3h-91.9C306.3,670,315,677.9,325.6,677.9z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(125, 125, 125)'}}
      />
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <path
          d="M 220.199997 657.5 H 273.099998 V 666 H 220.199997 V 657.5 Z"
          transform="matrix(0.866 -0.5 0.5 0.866 -297.8396 211.9916)"
          fill="#CC4552"
          style={{fill: 'rgb(194, 147, 52)'}}
        />
        <path
          fill="#8DBEB2"
          d="M232.3,661.4l5.9,10.2l-62.6,36.1c-10,5.8-22.7,2.3-28.5-7.6l-5.9-10.2l62.6-36.1&#10;&#9;&#9;&#9;&#9;&#9;C213.8,648,226.5,651.4,232.3,661.4z"
          style={{fill: 'rgb(150, 150, 150)'}}
        />
        <path
          fill="#7FB2A5"
          d="M203.8,653.7l-62.6,36.1l5.9,10.2c1.1,1.9,2.5,3.6,4,5l79.6-46C224.5,650.9,213,648.4,203.8,653.7z"
          style={{fill: 'rgb(125, 125, 125)'}}
        />
      </g>
      <path
        d="M 262.700012 633 H 315.600014 V 641.5 H 262.700012 V 633 Z"
        transform="matrix(0.8659999966621399, -0.5, 0.5, 0.8659999966621399, -387.5052795410156, -257.0386962890625)"
        fill="#CC4552"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
      <path
        fill="#8DBEB2"
        d="M303.6,637.6l-5.9-10.2l62.6-36.1c10-5.8,22.7-2.3,28.5,7.6l5.9,10.2L332,645.2&#10;&#9;&#9;&#9;&#9;&#9;C322.1,651,309.3,647.6,303.6,637.6z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(150, 150, 150)'}}
      />
      <path
        fill="#7FB2A5"
        d="M332,645.2l62.6-36.1l-5.9-10.2c-1.1-1.9-2.5-3.6-4-5l-79.6,46C311.4,648.1,322.9,650.5,332,645.2z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(125, 125, 125)'}}
      />
      <g transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)">
        <path
          d="M 229.199997 666.5 H 282.099998 V 675 H 229.199997 V 666.5 Z"
          transform="matrix(0.5 -0.866 0.866 0.5 -453.0706 556.7806)"
          fill="#CC4552"
          style={{fill: 'rgb(194, 147, 52)'}}
        />
        <path
          fill="#8DBEB2"
          d="M243,677.6l10.2,5.9l-36.1,62.6c-5.8,10-18.5,13.4-28.5,7.6l-10.2-5.9l36.1-62.6&#10;&#9;&#9;&#9;&#9;&#9;C220.3,675.3,233,671.8,243,677.6z"
          style={{fill: 'rgb(150, 150, 150)'}}
        />
        <path
          fill="#7FB2A5"
          d="M214.5,685.2l-36.1,62.6l10.2,5.9c1.9,1.1,3.9,1.9,6,2.3l46-79.6C231,672.4,219.8,676.1,214.5,685.2z"
          style={{fill: 'rgb(125, 125, 125)'}}
        />
      </g>
      <path
        d="M 253.699997 624 H 306.599998 V 632.5 H 253.699997 V 624 Z"
        transform="matrix(0.5, -0.8659999966621399, 0.8659999966621399, 0.5, -511.59796142578125, 69.77246856689453)"
        fill="#CC4552"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
      <path
        fill="#8DBEB2"
        d="M292.8,621.4l-10.2-5.9l36.1-62.6c5.8-10,18.5-13.4,28.5-7.6l10.2,5.9l-36.1,62.6&#10;&#9;&#9;&#9;&#9;&#9;C315.6,623.7,302.8,627.2,292.8,621.4z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(150, 150, 150)'}}
      />
      <path
        fill="#7FB2A5"
        d="M321.3,613.8l36.1-62.6l-10.2-5.9c-1.9-1.1-3.9-1.9-6-2.3l-46,79.6C304.8,626.5,316,622.9,321.3,613.8z"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(125, 125, 125)'}}
      />
      <path
        d="M 287.999994 649.5 A 20.1 20.1 0 0 1 267.899994 669.6 A 20.1 20.1 0 0 1 247.799994 649.5 A 20.1 20.1 0 0 1 267.899994 629.4 A 20.1 20.1 0 0 1 287.999994 649.5 Z"
        fill="#5C4C51"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
      />
      <path
        d="M 279.799994 649.5 A 11.9 11.9 0 0 1 267.899994 661.4 A 11.9 11.9 0 0 1 255.999994 649.5 A 11.9 11.9 0 0 1 267.899994 637.6 A 11.9 11.9 0 0 1 279.799994 649.5 Z"
        fill="#CC4552"
        transform="matrix(1, 0, 0, 1, -107.64338684082031, -487.0080871582031)"
        style={{fill: 'rgb(194, 147, 52)'}}
      />
    </svg>
  )
}

const Tank = (props) => {
  const percentage = clamp(
    (100 * (props.value - props.min)) / (props.max - props.min),
    0,
    100
  )
  return (
    <svg
      className="gauge"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={props.width || '100%'}
      viewBox="0 0 800 800"
      enableBackground="new 0 0 800 800"
      xmlSpace="preserve"
    >
      <defs>
        <linearGradient
          id={`${props.className}-stop-${percentage}`}
          x1="0"
          x2="0"
          y1="1"
          y2="0"
        >
          <stop offset={percentage + '%'} stopColor={props.fill || '#FF9900'} />
          <stop offset={percentage + '%'} stopColor="rgb(238, 243, 246)" />
        </linearGradient>
      </defs>
      <g>
        <g>
          <path
            className={props.danger ? 'danger' : ''}
            fill="#FFFFFF"
            d="M400.076,705.067c-84.675,0-164.311-4.338-224.237-12.214c-58.896-7.74-90.681-17.629-94.631-29.419h-0.42l-0.004-2.5v-156.95c-10.914-4.697-16.226-10.292-16.226-17.071c0-5.235,5.189-9.336,11.814-9.336c1.54,0,3.031,0.228,4.411,0.661V312.835c-7.928-2.104-16.226-5.555-16.226-12.953c0-5.235,5.189-9.336,11.814-9.336c1.54,0,3.03,0.228,4.411,0.663V155.561l-0.028,0.013c-0.828,0.352-1.694,0.624-2.583,0.813l-0.266,0.051c-0.423,0.079-0.768,0.131-1.12,0.172c-0.179,0.021-0.288,0.034-0.397,0.043c-0.456,0.042-0.924,0.069-1.4,0.069c-6.763,0-12.06-4.179-12.06-9.515c0-10.361,10.528-18.46,33.135-25.49c17.162-5.337,41.43-10.091,72.128-14.129c62.044-8.161,144.396-12.656,231.884-12.656c87.487,0,169.839,4.495,231.883,12.656c30.698,4.038,54.966,8.792,72.128,14.129c22.606,7.029,33.135,15.129,33.135,25.49c0,5.335-5.297,9.515-12.06,9.515c-0.477,0-0.944-0.027-1.406-0.069l-0.312-0.034c-0.431-0.05-0.775-0.103-1.116-0.167l-0.347-0.066c-0.892-0.19-1.758-0.462-2.576-0.81l-0.036-0.016V291.27c1.432-0.472,2.981-0.724,4.562-0.724c6.625,0,11.815,4.101,11.815,9.336c0,7.426-8.377,10.885-16.377,12.993v165.419c1.43-0.468,2.98-0.717,4.562-0.717c6.625,0,11.815,4.101,11.815,9.336c0,6.81-5.361,12.425-16.377,17.137v159.385h-0.424c-3.95,11.79-35.736,21.679-94.632,29.419C564.386,700.729,484.75,705.067,400.076,705.067z"
          />
          <path d="M400.076,97.433c87.382,0,169.617,4.487,231.557,12.634c30.556,4.019,54.684,8.742,71.712,14.038c21.114,6.566,31.376,14.123,31.376,23.103c0,3.874-4.28,7.015-9.559,7.015c-0.401,0-0.793-0.024-1.18-0.059c-0.111-0.01-0.219-0.024-0.329-0.037c-0.293-0.034-0.582-0.078-0.866-0.131c-0.096-0.018-0.193-0.034-0.288-0.054c-0.748-0.159-1.456-0.384-2.117-0.665c-0.063-0.027-0.124-0.055-0.187-0.083c-0.293-0.131-0.575-0.273-0.846-0.426c-0.033-0.019-0.067-0.036-0.1-0.055c-0.625-0.362-1.184-0.78-1.668-1.244c-0.02-0.02-0.04-0.039-0.06-0.059c-0.237-0.231-0.456-0.472-0.653-0.724l0,0v144.76c1.708-1.463,4.23-2.4,7.062-2.4c5.144,0,9.315,3.06,9.315,6.836c0,5.273-5.831,8.493-16.377,11.045v171.529c1.708-1.456,4.238-2.378,7.062-2.378c5.144,0,9.315,3.061,9.315,6.836c0,6.949-7.45,11.885-16.377,15.466v158.556h-0.004c-0.153,22.996-141.923,41.632-316.788,41.632c-174.865,0-316.635-18.636-316.788-41.632h-0.004V502.318c-8.86-3.575-16.226-8.495-16.226-15.405c0-3.775,4.17-6.836,9.315-6.836c2.744,0,5.206,0.875,6.911,2.26V310.891c-10.452-2.546-16.226-5.761-16.226-11.009c0-3.776,4.17-6.836,9.315-6.836c2.747,0,5.206,0.879,6.911,2.267V150.685c-0.197,0.252-0.416,0.493-0.653,0.724c-0.02,0.02-0.04,0.04-0.06,0.059c-0.485,0.464-1.043,0.882-1.668,1.244c-0.033,0.019-0.067,0.036-0.1,0.055c-0.271,0.153-0.553,0.294-0.846,0.425c-0.062,0.028-0.124,0.057-0.188,0.084c-0.66,0.281-1.369,0.506-2.117,0.665c-0.095,0.02-0.191,0.036-0.287,0.054c-0.284,0.053-0.573,0.097-0.866,0.132c-0.11,0.013-0.218,0.027-0.329,0.037c-0.388,0.035-0.78,0.059-1.18,0.059c-5.279,0-9.559-3.14-9.559-7.015c0-8.98,10.263-16.537,31.376-23.103c17.029-5.296,41.156-10.019,71.712-14.038C230.459,101.92,312.694,97.433,400.076,97.433 M400.076,92.433c-87.593,0-170.06,4.502-232.21,12.677c-30.837,4.056-55.244,8.84-72.545,14.22c-14.978,4.658-34.891,12.616-34.891,27.878c0,6.737,6.395,12.015,14.559,12.015c0.509,0,1.042-0.026,1.631-0.079c0.136-0.012,0.269-0.027,0.401-0.043l0.061-0.007c0.399-0.046,0.805-0.108,1.202-0.183v129.238c-0.628-0.068-1.266-0.102-1.911-0.102c-8.027,0-14.315,5.199-14.315,11.836c0,9.041,9.515,12.959,16.226,14.876v160.421c-0.628-0.068-1.266-0.102-1.911-0.102c-8.027,0-14.315,5.199-14.315,11.836c0,7.428,5.455,13.706,16.226,18.69v155.332v5h1.22c3.056,6.052,11.927,11.217,27.273,15.982c16.241,5.042,39.367,9.555,68.736,13.415c60.032,7.89,139.783,12.235,224.563,12.235c84.78,0,164.531-4.345,224.563-12.235c29.369-3.86,52.495-8.373,68.736-13.415c15.347-4.764,24.218-9.93,27.273-15.982h1.216l0.004-5V505.673c10.872-4.997,16.377-11.298,16.377-18.759c0-6.637-6.288-11.836-14.315-11.836c-0.697,0-1.386,0.04-2.062,0.118V314.801c6.765-1.918,16.377-5.842,16.377-14.919c0-6.637-6.288-11.836-14.315-11.836c-0.697,0-1.386,0.04-2.062,0.119V158.91c0.395,0.074,0.8,0.136,1.204,0.183l0.065,0.008c0.13,0.016,0.259,0.03,0.391,0.042c0.592,0.054,1.126,0.079,1.634,0.079c8.164,0,14.559-5.277,14.559-12.015c0-15.262-19.913-23.22-34.891-27.878c-17.299-5.38-41.707-10.164-72.545-14.22C570.135,96.935,487.668,92.433,400.076,92.433L400.076,92.433z" />
        </g>
        <path
          fill={`url(#${props.className}-stop-${percentage})`}
          stroke="#000000"
          strokeWidth="5"
          strokeMiterlimit="10"
          d="M701.046,154.505c-1.349-21.709-135.535-39.253-300.895-39.253s-299.546,17.544-300.895,39.253h-0.032v489.062h0.003c0.145,21.844,134.816,39.547,300.923,39.547s300.778-17.703,300.923-39.547h0.003V154.505H701.046z"
        />
      </g>
    </svg>
  )
}

export const WaterTank = (props) => (
  <Tank {...props} fill="rgb(130, 151, 172)" className="water" />
)
export const StockTank = (props) => (
  <Tank {...props} fill="rgb(71, 71, 71)" className="oil" />
)

export const ChemicalTank = (props) => {
  const percentage = clamp(
    (100 * (props.value - props.min)) / (props.max - props.min),
    0,
    100
  )
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
      <defs>
        <linearGradient
          id={`chem-stop-${percentage}`}
          x1="0"
          x2="0"
          y1="1"
          y2="0"
        >
          <stop offset={percentage + '%'} stopColor={props.fill || '#FF9900'} />
          <stop offset={percentage + '%'} stopColor="rgb(238, 243, 246)" />
        </linearGradient>
      </defs>
      <rect
        x="231.141"
        y="561.963"
        fill="#FFFFFF"
        stroke="#000000"
        strokeWidth="5"
        strokeMiterlimit="10"
        width="337.829"
        height="30.014"
      />
      <g stroke="#000" strokeWidth={5} strokeMiterlimit={10}>
        <path
          fill="#FFFFFF"
          d="M666.186,128.347v-0.018H134.222v0.002c-30.318,0.081-54.888,75.727-54.888,169.032s24.57,168.95,54.888,169.032v0.002h50.805v47.959h93.196v-47.959h243.553v47.959h93.196v-47.959h51.214v-0.018c30.13-0.758,54.479-76.132,54.479-169.016C720.665,204.478,696.316,129.104,666.186,128.347z"
        />
        <path
          fill={`url(#chem-stop-${percentage})`}
          d="M637.029,426.845c23.082-0.58,41.737-58.324,41.737-129.483s-18.654-128.903-41.737-129.483v-0.014H161.401v0.001c-23.227,0.063-42.05,58.015-42.05,129.495s18.823,129.433,42.05,129.495v0.001h475.628V426.845z"
        />
      </g>
      <rect
        x="216.134"
        y="128.43"
        fill="#FFFFFF"
        stroke="#000000"
        strokeWidth="5"
        strokeMiterlimit="10"
        width="30.014"
        height="543.241"
      />
      <rect
        x="553.963"
        y="128.43"
        fill="#FFFFFF"
        stroke="#000000"
        strokeWidth="5"
        strokeMiterlimit="10"
        width="30.014"
        height="543.241"
      />
    </svg>
  )
}

export const Pressure = (props) => {
  const min = props.min
  const max = props.max
  const toRotation = (v) => clamp(((v - min) * 270) / (max - min), 0, 270)
  const toPoint = (r, v) =>
    `${60 + r * Math.cos((Math.PI / 180) * (toRotation(v) - 225))},` +
    `${60 + r * Math.sin((Math.PI / 180) * (toRotation(v) - 225))}`
  const alarm = {
    low: clamp(
      props.alarm && isNum(props.alarm.low) ? props.alarm.low : min,
      min,
      max
    ),
    high: clamp(
      props.alarm && isNum(props.alarm.high)
        ? props.alarm.high
        : props.alarm && isNum(props.alarm.low)
        ? max
        : min,
      min,
      max
    )
  }
  const points = [
    toPoint(44, alarm.low),
    toPoint(44, alarm.high),
    toPoint(33, alarm.high),
    toPoint(33, alarm.low)
  ]
  const largeArcFlag =
    toRotation(alarm.high) - toRotation(alarm.low) > 180 ? 1 : 0
  return (
    <svg
      className="gauge"
      viewBox="0 0 120 120"
      width={props.width || '100%'}
      style={{overflow: 'hidden'}}
    >
      <defs id="defs" />
      <g>
        <circle
          className={props.danger ? 'danger-fill' : ''}
          cx="59.5"
          cy="59.5"
          r="54"
          stroke="#333333"
          strokeWidth="1"
          fill="#cccccc"
        />
        <circle
          cx="59.5"
          cy="59.5"
          r="48"
          stroke="#e0e0e0"
          strokeWidth="2"
          fill="#f7f7f7"
        />
        {props.alarm && (
          <path
            d={`M${points[0]}A44,44,0,${largeArcFlag},1,${points[1]}L${points[2]}A33,33,0,${largeArcFlag},0,${points[3]}Z`}
            stroke="none"
            strokeWidth="0"
            fill="#109618"
          />
        )}
        <path
          d="M88.58,26.54A44,44,0,0,1,88.58,26.54L81.43,34.91A33,33,0,0,0,81.43,34.91Z"
          stroke="none"
          strokeWidth="0"
          fill="#dc3912"
        />
        <text
          textAnchor="middle"
          x="60"
          y="49.2"
          fontFamily="arial"
          fontSize="12"
          stroke="none"
          strokeWidth="0"
          fill="#333333"
        >
          Pressure
        </text>
        <text
          textAnchor="start"
          x="37.231161645793165"
          y="84.86883835420683"
          fontFamily="arial"
          fontSize="6"
          stroke="none"
          strokeWidth="0"
          fill="#333333"
        >
          {min}
        </text>
        <text
          textAnchor="end"
          x="82.76883835420686"
          y="84.8688383542068"
          fontFamily="arial"
          fontSize="6"
          stroke="none"
          strokeWidth="0"
          fill="#333333"
        >
          {max}
        </text>
        {/*<path
          d="M26.24,80.69L22.48,82.99M22.34,72.24L18.15,73.6M20.52,63.11L16.14,63.45M20.89,53.81L16.54,53.12M27.96,36.72L24.4,34.14M34.28,29.89L31.42,26.54M42.02,24.72L40.02,20.8M50.76,21.49L49.73,17.22M69.24,21.49L70.27,17.22M77.98,24.72L79.97,20.8M85.72,29.89L88.58,26.54M92.04,36.72L95.6,34.14M99.11,53.81L103.46,53.12M99.48,63.11L103.86,63.45M97.66,72.24L101.85,73.6M93.76,80.69L97.52,82.99"
          stroke="#666666"
          strokeWidth="1"
          fillOpacity="1"
          fill="none"
        />*/}
        <path
          d="M35.11,84.89L28.89,91.11M27.48,46.53L19.35,43.16M60,24.8L60,16M92.52,46.53L100.65,43.16M84.89,84.89L91.11,91.11"
          stroke="#ccc"
          strokeWidth="2"
          fillOpacity="1"
          fill="none"
        />
        <path
          d="M35.11,84.89L28.89,91.11M84.89,84.89L91.11,91.11"
          stroke="#333333"
          strokeWidth="2"
          fillOpacity="1"
          fill="none"
        />
        <g>
          <text
            textAnchor="middle"
            x="60"
            y="97.2"
            fontFamily="arial"
            fontSize="12"
            stroke="none"
            strokeWidth="0"
            fill="#000000"
          >
            {props.value || props.value === 0
              ? props.value.toFixed(1)
              : props.value}
          </text>
          <path
            style={{
              transformOrigin: '60px 60px',
              transform: `rotate(${toRotation(props.value)}deg)`
            }}
            d="M30.3,89.7C57.82,57.82,68.1,49.72,69.19,50.81C70.28,51.9,62.18,62.18,30.3,89.7"
            stroke="#c63310"
            strokeWidth="1"
            fillOpacity="0.7"
            fill="#dc3912"
          />
          <circle
            cx="60"
            cy="60"
            r="7"
            stroke="#666666"
            strokeWidth="1"
            fill="#4684ee"
          />
        </g>
      </g>
    </svg>
  )
}

// export const OilQuality = props => {
//   const min = props.min
//   const max = props.max
//   const toRotation = v => clamp(((v - min) * 270) / (max - min), 0, 270)
//   const toPoint = (r, v) =>
//     `${60 + r * Math.cos((Math.PI / 180) * (toRotation(v) - 225))},` +
//     `${60 + r * Math.sin((Math.PI / 180) * (toRotation(v) - 225))}`
//   const alarm = {
//     low: clamp(
//       props.alarm && isNum(props.alarm.low) ? props.alarm.low : min,
//       min,
//       max
//     ),
//     high: clamp(
//       props.alarm && isNum(props.alarm.high)
//         ? props.alarm.high
//         : props.alarm && isNum(props.alarm.low)
//         ? max
//         : min,
//       min,
//       max
//     )
//   }
//   const points = [
//     toPoint(44, alarm.low),
//     toPoint(44, alarm.high),
//     toPoint(33, alarm.high),
//     toPoint(33, alarm.low)
//   ]
//   const largeArcFlag =
//     toRotation(alarm.high) - toRotation(alarm.low) > 180 ? 1 : 0
//   return (
//     <svg
//       className="gauge"
//       viewBox="0 0 120 120"
//       width={props.width || '100%'}
//       style={{overflow: 'hidden'}}
//     >
//       <defs id="defs" />
//       <g>
//         <circle
//           className={props.danger ? 'danger-fill' : ''}
//           cx="59.5"
//           cy="59.5"
//           r="54"
//           stroke="#333333"
//           strokeWidth="1"
//           fill="#cccccc"
//         />
//         <circle
//           cx="59.5"
//           cy="59.5"
//           r="48"
//           stroke="#e0e0e0"
//           strokeWidth="2"
//           fill="#f7f7f7"
//         />
//         {props.alarm && (
//           <path
//             d={`M${points[0]}A44,44,0,${largeArcFlag},1,${points[1]}L${
//               points[2]
//             }A33,33,0,${largeArcFlag},0,${points[3]}Z`}
//             stroke="none"
//             strokeWidth="0"
//             fill="#109618"
//           />
//         )}
//         <path
//           d="M88.58,26.54A44,44,0,0,1,88.58,26.54L81.43,34.91A33,33,0,0,0,81.43,34.91Z"
//           stroke="none"
//           strokeWidth="0"
//           fill="#dc3912"
//         />
//         <text
//           textAnchor="middle"
//           x="60"
//           y="49.2"
//           fontFamily="arial"
//           fontSize="12"
//           stroke="none"
//           strokeWidth="0"
//           fill="#333333"
//         >
//           Oil Quality
//         </text>
//         <text
//           textAnchor="start"
//           x="37.231161645793165"
//           y="84.86883835420683"
//           fontFamily="arial"
//           fontSize="6"
//           stroke="none"
//           strokeWidth="0"
//           fill="#333333"
//         >
//           {min}
//         </text>
//         <text
//           textAnchor="end"
//           x="82.76883835420686"
//           y="84.8688383542068"
//           fontFamily="arial"
//           fontSize="6"
//           stroke="none"
//           strokeWidth="0"
//           fill="#333333"
//         >
//           {max}
//         </text>
//         <path
//           d="M26.24,80.69L22.48,82.99M22.34,72.24L18.15,73.6M20.52,63.11L16.14,63.45M20.89,53.81L16.54,53.12M27.96,36.72L24.4,34.14M34.28,29.89L31.42,26.54M42.02,24.72L40.02,20.8M50.76,21.49L49.73,17.22M69.24,21.49L70.27,17.22M77.98,24.72L79.97,20.8M85.72,29.89L88.58,26.54M92.04,36.72L95.6,34.14M99.11,53.81L103.46,53.12M99.48,63.11L103.86,63.45M97.66,72.24L101.85,73.6M93.76,80.69L97.52,82.99"
//           stroke="#666666"
//           strokeWidth="1"
//           fillOpacity="1"
//           fill="none"
//         />
//         <path
//           d="M35.11,84.89L28.89,91.11M27.48,46.53L19.35,43.16M60,24.8L60,16M92.52,46.53L100.65,43.16M84.89,84.89L91.11,91.11"
//           stroke="#333333"
//           strokeWidth="2"
//           fillOpacity="1"
//           fill="none"
//         />
//         <g>
//           <text
//             textAnchor="middle"
//             x="60"
//             y="97.2"
//             fontFamily="arial"
//             fontSize="12"
//             stroke="none"
//             strokeWidth="0"
//             fill="#000000"
//           >
//             {props.value || props.value === 0
//               ? props.value.toFixed(1)
//               : props.value}
//           </text>
//           <path
//             style={{
//               transformOrigin: '60px 60px',
//               transform: `rotate(${toRotation(props.value)}deg)`
//             }}
//             d="M30.3,89.7C57.82,57.82,68.1,49.72,69.19,50.81C70.28,51.9,62.18,62.18,30.3,89.7"
//             stroke="#c63310"
//             strokeWidth="1"
//             fillOpacity="0.7"
//             fill="#dc3912"
//           />
//           <circle
//             cx="60"
//             cy="60"
//             r="7"
//             stroke="#666666"
//             strokeWidth="1"
//             fill="#4684ee"
//           />
//         </g>
//       </g>
//     </svg>
//   )
// }

export const BeamPump = (props) => (
  <svg
    className="gauge"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 800"
    width={props.width || '100%'}
  >
    <g
      className={props.danger ? 'danger-stroke' : ''}
      stroke="#231f20"
      strokeWidth="5px"
      style={{strokeMiterlimit: '10'}}
    >
      <g style={{fill: '#c0c0c4'}}>
        <path d="M405.93,359.08l42.75,114.23-43.24,38.92L362.2,473.31l42.46-113.44L347.54,395,243.46,673.1h44l1.16-3.09L405.45,564.83,522.3,670l1.16,3.09h44l-125.76-336ZM318.27,590.69l29.21-78,28.75,25.88Zm174.35,0-58-52.16,28.75-25.88Z" />
        <path d="M706,673.1H198.67V597.8c0-5.52-4.21-10-9.38-10a8.83,8.83,0,0,0-2.24.29l-22.13,5.79-17.82,4.66-26.16,6.85a9.9,9.9,0,0,0-7.13,9.7v58H70.85V737h658.3V673.1Z" />
      </g>
      <g style={{fill: '#e8e8e8'}}>
        <polygon points="688.17 346.18 688.17 673.1 705.99 673.1 705.14 351 705.14 351 688.17 346.18" />
        <polygon points="164.91 485.94 147.09 475.5 147.09 598.55 164.91 593.89 164.91 485.94" />
        <path d="M668.85,172.8C639.69,119,578.27,63,578.27,63L508.4,106l42.95,79.3L132.93,442.9c-6.29,3.85-8.46,12.4-4.85,19.11a13.58,13.58,0,0,0,5,5.29l14,8.2,17.82,10.45,11.35,6.66a12.42,12.42,0,0,0,12.94-.1L347.54,395l57.12-35.16,1.27-.78,35.73-22L585.58,248.5l43.89,81,58.7,16.68,17,4.82s.35-4.56.45-12.5C706,309.66,703.11,236.07,668.85,172.8Z" />
      </g>
    </g>
  </svg>
)


export const ValvePosition = (props) => {
  return (
    <svg fill="#000000" 
    height="200px" 
    width="200px" 
    version="1.1" 
    id="Layer_1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    viewBox="0 0 512 512" xmlSpace="preserve">
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
    <g id="SVGRepo_iconCarrier"> 
    <g> 
    <g> 
    <path d="M490.667,298.667H448v-21.333c0-11.782-9.551-21.333-21.333-21.333h-64c-11.782,0-21.333,9.551-21.333,21.333v21.333H320 v-85.333c0-11.782-9.551-21.333-21.333-21.333h-21.333v-42.667h85.333c11.782,0,21.333-9.551,21.333-21.333V21.333 C384,9.551,374.449,0,362.667,0H256H149.333C137.551,0,128,9.551,128,21.333V128c0,11.782,9.551,21.333,21.333,21.333h85.333V192 h-21.333C201.551,192,192,201.551,192,213.333v85.333h-21.333v-21.333c0-11.782-9.551-21.333-21.333-21.333h-64 C73.551,256,64,265.551,64,277.333v21.333H21.333C9.551,298.667,0,308.218,0,320v128c0,11.782,9.551,21.333,21.333,21.333H64 v21.333C64,502.449,73.551,512,85.333,512h64c11.782,0,21.333-9.551,21.333-21.333v-21.333h170.667v21.333 c0,11.782,9.551,21.333,21.333,21.333h64c11.782,0,21.333-9.551,21.333-21.333v-21.333h42.667 c11.782,0,21.333-9.551,21.333-21.333V320C512,308.218,502.449,298.667,490.667,298.667z M341.333,106.667h-64v-64h64V106.667z M170.667,42.667h64v64h-64V42.667z M234.667,234.667h42.667v64h-42.667V234.667z M42.667,426.667v-85.333H64v85.333H42.667z M128,469.333h-21.333V448V320v-21.333H128V320v128V469.333z M170.667,426.667v-85.333h42.667h85.333h42.667v85.333H170.667z M405.333,469.333H384V448V320v-21.333h21.333V320v128V469.333z M469.333,426.667H448v-85.333h21.333V426.667z"></path> 
    </g> 
    </g> 
    </g>
    </svg>
  ) 
}

export const Sensor = (props) => (
  <svg viewBox="-62 -2 304 184" xmlns="http://www.w3.org/2000/svg">
    <rect
      rx="30"
      height="180"
      width="180"
      y="0"
      x="0"
      strokeWidth="2"
      stroke="#000"
      fill="#fff"
    />
    <rect height="30" width="120" y="30" x="30" fill="#777" stroke={0} />
    <rect height="30" width="120" y="60" x="30" fill="#888" stroke={0} />
    <rect height="30" width="120" y="90" x="30" fill="#777" stroke={0} />
    <rect height="30" width="120" y="120" x="30" fill="#888" stroke={0} />
  </svg>
)

export const Gateway = (props) => (
  <svg viewBox="-2 -2 304 184" xmlns="http://www.w3.org/2000/svg">
    <rect
      rx="30"
      height="180"
      width="300"
      y="0"
      x="0"
      strokeWidth="2"
      stroke="#000"
      fill="#fff"
    />
    <rect height="30" width="240" y="30" x="30" fill="#777" stroke={0} />
    <rect height="30" width="240" y="60" x="30" fill="#888" stroke={0} />
    <rect height="30" width="240" y="90" x="30" fill="#777" stroke={0} />
    <rect height="30" width="240" y="120" x="30" fill="#888" stroke={0} />
  </svg>
)

export const PCPump = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
    <g style={{stroke: '#231f20', strokeMiterlimit: 10, strokeWidth: '5px'}}>
      <g style={{fill: '#e5e5e5'}}>
        <rect
          x="241.25"
          y="246.88"
          width="14.44"
          height="29.09"
          transform="translate(-12.95 509.89) rotate(-90)"
        />
        <path d="M460.46,683.41H604.27a5,5,0,0,1,5,5V712.5a0,0,0,0,1,0,0H455.46a0,0,0,0,1,0,0V688.41A5,5,0,0,1,460.46,683.41Z" />
        <rect x="363.31" y="377.89" width="75.29" height="29.09" />
        <rect x="363.31" y="479.22" width="75.29" height="29.09" />
        <rect x="500.24" y="623.23" width="64.24" height="60.19" />
      </g>
      <path
        style={{fill: '#bfbfbf'}}
        className={props.danger ? 'danger-fill' : ''}
        d="M363.3,305.65c-.51-20.47-51.72-37-114.83-37s-114.31,16.54-114.83,37V580.54c.52,20.47,51.73,37,114.83,37s114.32-16.55,114.83-37Z"
      />
      <g style={{fill: '#e5e5e5'}}>
        <polygon points="609.27 267.79 609.27 239.76 455.46 239.76 455.46 623.23 609.27 623.23 609.27 370.5 609.27 357.75 609.27 280.53 609.27 267.79" />
        <rect x="455.46" y="87.5" width="153.81" height="46.91" />
        <polygon points="455.46 134.41 149.95 134.41 149.95 239.76 666.36 239.76 666.36 134.41 455.46 134.41" />
        <path d="M443.6,363.6h11.86a0,0,0,0,1,0,0v57.67a0,0,0,0,1,0,0H443.6a5,5,0,0,1-5-5V368.6A5,5,0,0,1,443.6,363.6Z" />
        <path d="M443.6,464.93h11.86a0,0,0,0,1,0,0V522.6a0,0,0,0,1,0,0H443.6a5,5,0,0,1-5-5V469.93A5,5,0,0,1,443.6,464.93Z" />
        <path
          d="M245,219.36H256.9a0,0,0,0,1,0,0V277a0,0,0,0,1,0,0H245a5,5,0,0,1-5-5V224.36a5,5,0,0,1,5-5Z"
          transform="translate(0.28 496.66) rotate(-90)"
        />
      </g>
      <g style={{fill: 'none', strokeLinecap: 'round'}}>
        <line x1="210.05" y1="523.98" x2="210.05" y2="291.91" />
        <line x1="197.24" y1="293.83" x2="197.24" y2="522.06" />
        <line x1="222.85" y1="525.27" x2="222.85" y2="290.62" />
        <line x1="235.66" y1="526.03" x2="235.66" y2="289.86" />
        <line x1="184.43" y1="296.51" x2="184.43" y2="519.38" />
        <line x1="171.62" y1="515.66" x2="171.62" y2="300.23" />
        <line x1="158.81" y1="305.83" x2="158.81" y2="510.06" />
        <line x1="248.47" y1="526.28" x2="248.47" y2="289.61" />
        <line x1="325.33" y1="515.66" x2="325.33" y2="300.23" />
        <line x1="312.52" y1="296.51" x2="312.52" y2="519.38" />
        <line x1="338.13" y1="510.06" x2="338.13" y2="305.83" />
        <line x1="299.71" y1="293.82" x2="299.71" y2="522.06" />
        <line x1="286.9" y1="523.98" x2="286.9" y2="291.91" />
        <line x1="274.09" y1="290.61" x2="274.09" y2="525.27" />
        <line x1="261.28" y1="289.86" x2="261.28" y2="526.03" />
      </g>
    </g>
  </svg>
)

export const ChemicalPump = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
    <path
      fill="#FFFFFF"
      d="M446.605,151.636c-14.735,0-26.724-12.264-26.724-27s11.988-27,26.724-27h234.9
        c14.735,0,26.723,12.265,26.723,27s-11.987,27-26.723,27H446.605z"
    />
    <path
      d="M681.506,100.636c13.389,0,24.223,10.623,24.223,24c0,13.377-10.834,24-24.223,24H446.605
        c-13.389,0-24.223-10.623-24.223-24c0-13.377,10.834-24,24.223-24H682 M681.506,95.636H446.605
        c-16.114,0-29.223,12.886-29.223,29s13.109,29,29.223,29h234.901c16.114,0,29.223-12.886,29.223-29
        S697.619,95.636,681.506,95.636L681.506,95.636z"
    />
    <polygon
      fill="#FFFFFF"
      stroke="#000000"
      strokeWidth="5"
      strokeMiterlimit="10"
      points="191.274,700.136 433.506,280.579 
    675.737,700.136   "
    />
    <path
      fill="#D1D3D4"
      className={props.danger ? 'danger-fill' : ''}
      d="M433.506,587.175c-65.37,0-126.828-25.457-173.051-71.681s-71.68-107.681-71.68-173.051
      s25.457-126.828,71.68-173.052s107.681-71.68,173.051-71.68s126.827,25.456,173.051,71.68s71.681,107.682,71.681,173.052
      s-25.457,126.827-71.681,173.051S498.876,587.175,433.506,587.175z"
    />
    <path
      d="M433.506,100.212c133.781,0,242.231,108.451,242.231,242.231c0,133.78-108.451,242.231-242.231,242.231
        S191.274,476.224,191.274,342.443C191.274,208.663,299.725,100.212,433.506,100.212 M433.506,95.212
        c-33.374,0-65.752,6.538-96.235,19.431c-29.441,12.453-55.88,30.278-78.584,52.982c-22.704,22.704-40.529,49.143-52.982,78.583
        c-12.893,30.483-19.431,62.861-19.431,96.235c0,33.374,6.537,65.752,19.431,96.235c12.452,29.441,30.278,55.88,52.982,78.584
        c22.704,22.704,49.143,40.529,78.584,52.981c30.483,12.893,62.861,19.431,96.235,19.431c33.374,0,65.752-6.538,96.235-19.431
        c29.441-12.453,55.88-30.278,78.584-52.981c22.704-22.704,40.529-49.143,52.982-78.584
        c12.893-30.483,19.431-62.861,19.431-96.235c0-33.374-6.537-65.752-19.431-96.235c-12.452-29.44-30.278-55.88-52.982-78.583
        c-22.704-22.704-49.143-40.529-78.584-52.982C499.258,101.75,466.88,95.212,433.506,95.212L433.506,95.212z"
    />
    <circle
      fill="#FFFFFF"
      stroke="#000000"
      strokeWidth="5"
      strokeMiterlimit="10"
      cx="433.506"
      cy="342.443"
      r="62.503"
    />
    <path
      fill="#FFFFFF"
      d="M118.605,369.636c-14.735,0-26.723-12.264-26.723-27s11.988-27,26.723-27h314.901
        c14.735,0,26.723,12.265,26.723,27s-11.987,27-26.723,27H118.605z"
    />
    <path
      d="M433.506,318.636c13.389,0,24.223,10.623,24.223,24c0,13.377-10.834,24-24.223,24H118.605
        c-13.389,0-24.223-10.623-24.223-24c0-13.377,10.834-24,24.223-24H434 M433.506,313.636H118.605
        c-16.114,0-29.223,12.886-29.223,29s13.109,29,29.223,29h314.901c16.114,0,29.223-12.886,29.223-29
        S449.619,313.636,433.506,313.636L433.506,313.636z"
    />
    <circle
      fill="#D1D3D4"
      stroke="#000000"
      strokeWidth="5"
      strokeMiterlimit="10"
      cx="433.506"
      cy="342.443"
      r="32.623"
    />
  </svg>
)

export const ChemicalTankVertical = (props) => {
  const percentage = clamp(
    (100 * (props.value - props.min)) / (props.max - props.min),
    0,
    100
  )
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
      <defs>
        <linearGradient
          id={`chem-stop-${percentage}`}
          x1="0"
          x2="0"
          y1="1"
          y2="0"
        >
          <stop offset={percentage + '%'} stopColor={props.fill || '#FF9900'} />
          <stop offset={percentage + '%'} stopColor="rgb(238, 243, 246)" />
        </linearGradient>
      </defs>

      <path
        fill="#FFFFFF"
        d="M400,745.067c-44.188,0-85.769-4.937-117.083-13.9c-18.684-5.349-50.035-17.102-50.092-35.728
      l-0.002-178.488c-5.599-5.257-8.436-11.491-8.436-18.548c0-5.741,3.226-10.239,7.343-10.239c0.37,0,0.735,0.036,1.093,0.107
      V300.571c-5.746-3.438-8.436-7.895-8.436-13.925c0-5.742,3.226-10.24,7.343-10.24c0.37,0,0.735,0.037,1.093,0.108v-152.59
      c-0.136,0.045-0.271,0.085-0.406,0.12c-0.127,0.033-0.22,0.056-0.315,0.074c-0.379,0.075-0.739,0.113-1.091,0.113
      c-4.188,0-7.469-4.586-7.469-10.442c0-11.06,5.694-20.293,17.408-28.228c9.071-6.145,21.854-11.604,37.991-16.227
      C311.358,60.047,354.351,54.933,400,54.933c45.648,0,88.642,5.114,121.059,14.401c16.138,4.623,28.92,10.083,37.991,16.227
      c11.714,7.934,17.408,17.167,17.408,28.228c0,5.855-3.281,10.442-7.47,10.442c-0.353,0-0.713-0.038-1.102-0.115
      c-0.088-0.017-0.187-0.041-0.285-0.067c-0.146-0.038-0.288-0.079-0.425-0.125V276.53c0.383-0.082,0.773-0.124,1.171-0.124
      c4.117,0,7.343,4.498,7.343,10.24c0,6.053-2.714,10.525-8.514,13.97v187.67c0.383-0.081,0.773-0.122,1.171-0.122
      c4.117,0,7.343,4.498,7.343,10.239c0,7.088-2.863,13.348-8.514,18.62v178.408c-0.058,18.634-31.41,30.387-50.094,35.735
      C485.769,740.131,444.188,745.067,400,745.067z"
      />
      <path
        d="M400,57.433c45.424,0,88.172,5.08,120.37,14.304c15.884,4.55,28.426,9.898,37.278,15.894
      c10.975,7.434,16.31,15.99,16.31,26.157c0,4.387-2.225,7.942-4.969,7.942c-0.208,0-0.412-0.027-0.614-0.067
      c-0.058-0.011-0.114-0.027-0.171-0.042c-0.153-0.039-0.302-0.088-0.45-0.149c-0.05-0.021-0.1-0.039-0.149-0.061
      c-0.389-0.18-0.757-0.435-1.1-0.753c-0.033-0.03-0.065-0.063-0.097-0.094c-0.152-0.149-0.299-0.309-0.44-0.482
      c-0.017-0.021-0.035-0.041-0.052-0.062c-0.325-0.41-0.615-0.884-0.867-1.409c-0.01-0.022-0.021-0.044-0.031-0.067
      c-0.123-0.262-0.237-0.534-0.339-0.82v0v163.898c0.888-1.657,2.199-2.717,3.671-2.717c2.674,0,4.842,3.465,4.842,7.74
      c0,5.97-3.031,9.616-8.513,12.505v194.205c0.888-1.649,2.203-2.693,3.671-2.693c2.674,0,4.842,3.465,4.842,7.74
      c0,7.867-3.873,13.457-8.513,17.51v179.518h-0.002c-0.08,26.036-73.776,47.136-164.675,47.136
      c-90.899,0-164.596-21.1-164.675-47.136h-0.002V515.845c-4.606-4.048-8.435-9.618-8.435-17.442c0-4.274,2.168-7.74,4.842-7.74
      c1.427,0,2.706,0.99,3.592,2.559V299.11c-5.433-2.883-8.435-6.523-8.435-12.465c0-4.275,2.168-7.74,4.842-7.74
      c1.428,0,2.706,0.995,3.592,2.566V117.725c-0.102,0.286-0.216,0.558-0.339,0.82c-0.01,0.022-0.021,0.045-0.031,0.067
      c-0.252,0.525-0.542,0.999-0.867,1.409c-0.017,0.021-0.035,0.041-0.052,0.062c-0.141,0.173-0.288,0.333-0.44,0.482
      c-0.032,0.032-0.064,0.064-0.098,0.095c-0.343,0.318-0.711,0.572-1.1,0.752c-0.049,0.023-0.099,0.041-0.149,0.061
      c-0.148,0.06-0.298,0.11-0.45,0.149c-0.057,0.015-0.114,0.03-0.171,0.042c-0.201,0.04-0.405,0.067-0.614,0.067
      c-2.745,0-4.969-3.556-4.969-7.942c0-10.167,5.335-18.724,16.31-26.157c8.852-5.996,21.394-11.343,37.278-15.894
      C311.828,62.513,354.577,57.433,400,57.433 M400,52.433c-45.876,0-89.113,5.149-121.747,14.498
      c-16.392,4.696-29.415,10.268-38.705,16.561c-12.28,8.317-18.506,18.511-18.506,30.297c0,6.957,4.024,12.468,9.281,12.913V274.03
      c-4.829,0.859-8.435,6.092-8.435,12.616c0,6.461,2.765,11.49,8.435,15.298v183.844c-4.829,0.859-8.435,6.092-8.435,12.616
      c0,7.437,2.836,14.023,8.435,19.608v177.42v5h0.674c3.547,13.127,21.079,24.507,51.232,33.138
      c31.532,9.026,73.358,13.997,117.771,13.997c44.414,0,86.239-4.971,117.771-13.997c30.153-8.631,47.685-20.012,51.232-33.138
      h0.672l0.002-5V518.089c5.651-5.601,8.513-12.214,8.513-19.685c0-6.559-3.645-11.813-8.513-12.629V301.994
      c5.722-3.816,8.513-8.861,8.513-15.349c0-6.559-3.645-11.813-8.513-12.629V126.702c5.257-0.445,9.281-5.957,9.281-12.913
      c0-11.786-6.226-21.98-18.506-30.297c-9.29-6.293-22.312-11.864-38.705-16.561C489.113,57.582,445.876,52.433,400,52.433
      L400,52.433z"
      />
      <path
        fill={`url(#chem-stop-${percentage})`}
        stroke="#000000"
        strokeWidth="5"
        strokeMiterlimit="10"
        d="M546.679,122.05
    C546.021,97.472,480.609,77.608,400,77.608S253.979,97.472,253.321,122.05h-0.015v553.717h0.002
    c0.071,24.732,65.719,44.775,146.692,44.775s146.622-20.043,146.692-44.775h0.002V122.05H546.679z"
      />
    </svg>
  )
}

export const ApacheChemicalTank = (props) => {
  const percentage = clamp(
    (100 * (props.value - props.min)) / (props.max - props.min),
    0,
    100
  )

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
      <defs>
        <linearGradient
          id={`chem-stop-${percentage}`}
          x1="0"
          x2="0"
          y1="1"
          y2="0"
        >
          <stop offset={percentage + '%'} stopColor={props.fill || '#FF9900'} />
          <stop offset={percentage + '%'} stopColor="rgb(238, 243, 246)" />
        </linearGradient>
      </defs>
      <g style={{stroke: '#231f20', strokeMiterlimit: 10, strokeWidth: 5}}>
        <path
          style={{fill: '#c5c5c4'}}
          d="M647.47,237.66h-2.65v-78s0-25.58-194.08-29.4V96.36s0-8.6-50.74-8.6-50.74,8.6-50.74,8.6v33.91c-194.17,3.81-194.08,29.4-194.08,29.4v78h-2.65a9.8,9.8,0,0,0,0,19.6h2.65V694.84s0,29.87,244.88,29.87,244.76-29.87,244.76-29.87V257.26h2.65a9.8,9.8,0,0,0,0-19.6Z"
        />{' '}
        <path
          fill={`url(#chem-stop-${percentage})`}
          d="M400.06,707c-83.59,0-147.25-3.46-189.22-10.29-22.33-3.64-33.14-7.41-38-9.62V167.37c4.83-2.2,15.64-6,38-9.61,41.93-6.82,105.55-10.28,189.1-10.28s147.25,3.46,189.22,10.29c22.33,3.64,33.14,7.41,38,9.62V687.13c-4.83,2.2-15.64,6-38,9.61C547.23,703.56,483.61,707,400.06,707Z"
        />
        <path
          style={{fill: '#c5c5c4'}}
          d="M352.34,74.55h95.33a16.91,16.91,0,0,1,16.91,16.91v14.86a0,0,0,0,1,0,0H335.42a0,0,0,0,1,0,0V91.46A16.91,16.91,0,0,1,352.34,74.55Z"
        />
      </g>
    </svg>
  )
}

export const CheckpointPump = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 800 800"
    transform="scale(-1, 1)"
  >
    <g style={{stroke: '#231f20', strokeMiterlimit: 10, strokeWidth: 5}}>
      <g style={{fill: '#c5c5c4'}}>
        <path
          className="cls-3"
          d="M651.65,261.1a3.84,3.84,0,0,0-3.84-3.84H574.63a3.84,3.84,0,0,0-3.84,3.84v73.13h80.86Z"
        />
        <path
          className="cls-3"
          d="M663.18,208.91H559.26a3.84,3.84,0,0,0-3.84,3.84v24.4H590.1v20.11h42.23V237.15H667v-24.4A3.83,3.83,0,0,0,663.18,208.91Z"
        />
      </g>
      <g style={{fill: '#fff'}}>
        <rect x="354.52" y="412.3" width="27.73" height="100.72" />
        <rect x="210.4" y="412.3" width="16.9" height="100.72" />
      </g>
      <rect
        style={{fill: '#eef5f7'}}
        x="84.75"
        y="388.83"
        width="125.65"
        height="147.64"
        rx="28.13"
        ry="28.13"
        transform="translate(295.15 925.31) rotate(180)"
      />
      <path
        style={{fill: '#c5c5c4'}}
        d="M338,359.2H244.07a12,12,0,0,0-11.75,9.56l-4.77,23a11.75,11.75,0,0,0-.25,2.44V535.08a12.24,12.24,0,0,0,.32,2.76l4.5,19a12,12,0,0,0,11.68,9.24h94.45A12,12,0,0,0,350,556.49l3.82-18.83a12,12,0,0,0,.24-2.39V394a11.5,11.5,0,0,0-.19-2.11l-4.05-22.78A12,12,0,0,0,338,359.2Z"
      />
      <path
        style={{fill: '#eef5f7'}}
        d="M673.85,591.09c22.9-.58,41.4-57.85,41.4-128.43s-18.5-127.86-41.4-128.43H412.53c-22.9.57-42.39,57.85-42.39,128.43s19.49,127.85,42.39,128.43Z"
      />{' '}
      <g style={{fill: '#fff'}}>
        <circle className="cls-4" cx="147.58" cy="462.66" r="39.35" />
        <circle className="cls-4" cx="147.58" cy="462.66" r="20.73" />
      </g>
      <line className="cls-6" x1="227.3" y1="392.93" x2="354.07" y2="392.93" />
      <line className="cls-6" x1="227.3" y1="536.48" x2="354.07" y2="536.48" />
    </g>
  </svg>
)

export const Thermometer = ({min, max, value}) => {
  const percentage = clamp((100 * (value - min)) / (max - min), 0, 100)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 800 800"
    >
      <defs>
        <linearGradient
          id={`thermometer-stop-${percentage}`}
          x1="0"
          x2="0"
          y1="1"
          y2="0"
        >
          <stop offset={percentage + '%'} stopColor="#d28887" />
          <stop offset={percentage + '%'} stopColor="#FFFFFF" />
        </linearGradient>
      </defs>
      <g stroke="#000000" strokeWidth="5" strokeMiterlimit="10">
        <path
          fill="#FFFFFF"
          d="M457.04,542.293V112.549
    c0-29.698-24.299-53.997-53.997-53.997h-6.086c-29.698,0-53.997,24.299-53.997,53.997v429.744
    c-30.446,19.039-50.702,52.857-50.702,91.413c0,59.505,48.238,107.742,107.742,107.742s107.742-48.238,107.742-107.742
    C507.742,595.151,487.486,561.332,457.04,542.293z"
        />
        <path
          fill={`url(#thermometer-stop-${percentage})`}
          d="M431.63,561.537V121.548
    c0-17.396-14.233-31.63-31.63-31.63h0c-17.396,0-31.63,14.233-31.63,31.63v439.989c-28.282,12.243-48.076,40.389-48.076,73.169
    c0,44.02,35.686,79.706,79.706,79.706s79.706-35.686,79.706-79.706C479.706,601.926,459.912,573.78,431.63,561.537z"
        />
      </g>
    </svg>
  )
}

export const SCADA = (props) => {
  return(
    <svg fill="#000000" 
    height="200px" 
    width="200px" 
    version="1.1" 
    id="Layer_1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlnsXlink="http://www.w3.org/1999/xlink" 
    viewBox="0 0 512 512" 
    xmlSpace="preserve">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier"> 
        <g> 
          <g> 
          <path d="M272.696,378.435h-33.391c-9.206,0-16.696,7.49-16.696,16.696s7.49,16.696,16.696,16.696h33.391 c9.206,0,16.696-7.49,16.696-16.696S281.902,378.435,272.696,378.435z"></path> 
          </g> 
        </g> 
        <g> 
          <g> <path d="M256,233.739c-12.271,0-22.261,9.984-22.261,22.261c0,12.277,9.99,22.261,22.261,22.261 c12.271,0,22.261-9.984,22.261-22.261C278.261,243.723,268.271,233.739,256,233.739z"></path> </g> 
        </g> 
        <g> 
          <g> <path d="M256,0C114.837,0,0,114.843,0,256s114.837,256,256,256s256-114.843,256-256S397.163,0,256,0z M272.696,445.217h-33.391 c-27.619,0-50.087-22.468-50.087-50.087s22.468-50.087,50.087-50.087h33.391c27.619,0,50.087,22.468,50.087,50.087 S300.315,445.217,272.696,445.217z M389.793,389.793c-6.522,6.522-17.086,6.522-23.609,0l-23.609-23.609 c-6.521-6.516-6.521-17.092,0-23.609c6.521-6.521,17.087-6.521,23.609,0l11.185,11.179c18.796-23.271,30.25-51.24,33.399-81.06 H395.13c-9.217,0-16.696-7.473-16.696-16.696c0-9.223,7.479-16.696,16.696-16.696h15.691 c-3.147-29.82-14.697-57.749-33.495-81.021l-72.174,72.174c4.014,7.687,6.5,16.288,6.5,25.543 c0,30.684-24.968,55.652-55.652,55.652s-55.652-24.968-55.652-55.652c0-30.684,24.968-55.652,55.652-55.652 c9.255,0,17.855,2.487,25.543,6.5l72.174-72.174c-23.273-18.798-51.202-30.348-81.022-33.496v15.691 c0,9.223-7.479,16.696-16.696,16.696c-9.217,0-16.696-7.473-16.696-16.696v-15.691c-29.82,3.148-57.749,14.697-81.022,33.495 l11.142,11.14c6.521,6.516,6.521,17.092,0,23.609c-3.261,3.261-7.533,4.892-11.804,4.892c-4.271,0-8.544-1.631-11.804-4.892 l-11.142-11.14c-18.798,23.273-30.349,51.202-33.496,81.022h15.691c9.217,0,16.696,7.473,16.696,16.696 c0,9.223-7.479,16.696-16.696,16.696h-15.638c3.15,29.82,14.603,57.788,33.399,81.06l11.185-11.179 c6.521-6.521,17.087-6.521,23.609,0c6.521,6.516,6.521,17.092,0,23.609l-23.609,23.609c-6.521,6.521-17.087,6.521-23.609,0 c-73.332-73.332-74.386-193.201,0-267.587c73.801-73.811,193.823-73.774,267.587,0 C463.142,195.555,464.16,315.427,389.793,389.793z"></path> </g> 
          </g> 
        </g>
    </svg>
  )

}
